import { render, staticRenderFns } from "./FindBestDesignsBlocks.vue?vue&type=template&id=2c18a4c0&scoped=true"
import script from "./FindBestDesignsBlocks.vue?vue&type=script&lang=js"
export * from "./FindBestDesignsBlocks.vue?vue&type=script&lang=js"
import style0 from "./FindBestDesignsBlocks.vue?vue&type=style&index=0&id=2c18a4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18a4c0",
  null
  
)

export default component.exports